export function HomeListItemImage({ image }: { image: string }) {
  return (
    <img
      alt="Landing home thumbnail"
      className="h-full min-h-22 w-16 max-w-16 rounded-bl-xl object-cover"
      src={`${image}?width=400&height=400`}
      style={{ borderTopRightRadius: 0, borderTopLeftRadius: 12 }}
    />
  )
}
